import { useContext } from 'react';
import { WorkPeriodsContext } from './components/Context';
import { WorkPeriodsContextState } from './types';

export const useWorkPeriods = (): WorkPeriodsContextState => {
  const context = useContext(WorkPeriodsContext);

  if (context === undefined) {
    throw Error(
      'WorkPeriodsContext must be used inside WorkPeriods Context Provider scope'
    );
  }

  return context;
};
